import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name:'formatDate'
})
export class FormatDatePipe implements PipeTransform{
    transform(value: number): string {
        //reformat as mm/dd/yyyy
        let newDate = value.toString();
        newDate = newDate.substr(4,2) + '/' +  newDate.substr(6,2) + '/' +newDate.substr(0,4);
        return newDate
    }
}
